import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import classNames from 'classnames'
import styles from '../../../styles'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { connect } from 'react-redux'
import { displayModal } from '../../reducers/modal/actions'
import { modalTypes } from '../../../enums/modalTypeEnum'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'
import { FilesModel } from '../../requests/downloadFiles/filesModel'
import fetchFactory from '../../../utils/fetchFactory'
import { RootState } from '../../reducers'
import { saveFiles } from '../../reducers/youfirstFiles/actions'
import contractsTabEnum from '../../../enums/contractsTabEnum'
import { useMediaQuery } from 'react-responsive'
import { convertFileList, REPARATIONS } from '../../requests/downloadFiles/filesMapper'
import { saveInteractions } from '../../gtm/utils/gtmCallback'
import portals from '../../../enums/portalsEnum'

const useStyles = makeStyles((theme) => {
    return {
        ...styles(theme),
        dashboardHeaderSubmenuStyle: {
            background: theme.palette.blue.main,
            position: 'absolute',
            right: 0,
            width: '96%',
            display: 'flex',
            justifyContent: 'center',
            boxSizing: 'border-box',

            '& .links': {
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',

                '& span:not(.MuiBadge-root)': {
                    display: 'flex',
                    alignItems: 'center'
                },
                '& img': {
                    width: 32,
                    height: 32,
                    marginRight: 20
                },

                '& .MuiBadge-root': {
                    marginRight: 20,

                    '& img': {
                        width: 32,
                        height: 32,
                        marginRight: 0
                    }
                }
            }
        },
        submenuLargeScreenStyle: {
            bottom: -40,
            padding: '24px 0 24px 60px',

            '& .links': {
                marginRight: 50
            }
        },
        submenuSmallScreenStyle: {
            bottom: -141.5,
            flexDirection: 'column',
            padding: 25,

            '& .links:not(:last-child)': {
                marginBottom: 35
            },
            '& .links svg:last-child': {
                marginLeft: 'auto'
            }
        },
        customBadgeStyle: {
            color: 'white',
            backgroundColor: theme.palette.dynamic.main
        },
        widthTablet: {
            width: '60%'
        }
    }
})

interface Store {
    files: FilesModel[],
    saveFiles: (files: FilesModel[]) => void,
    displayModal: (modalType: string, content?: any) => void,
}

type DashboardHeaderSubmenuProps = Store

const DashboardHeaderSubmenu: React.FC<DashboardHeaderSubmenuProps> = (
    {
        displayModal,
        files,
        saveFiles,
    }
) => {
    const classes = useStyles()
    const history = useHistory()
    const intl = useIntl()

    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 960px)'
        }
    )
    const isDesktopScreen = useMediaQuery(
        {
            query: '(min-width: 770px)'
        }
    )

    const submenuClass = classNames(
        isLargeScreen ? classes.submenuLargeScreenStyle : classes.submenuSmallScreenStyle,
        { [classes.widthTablet]: isDesktopScreen && !isLargeScreen },
        classes.dashboardHeaderSubmenuStyle
    )
    const linksClass = classNames(
        'links',
        classes.text4
    )

    useEffect(() => {
        fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getDocuments?language=${intl.locale}`)
            .then(
                (response: any) => {
                    saveFiles(convertFileList(response))
                }
            )
    }, [intl.locale, saveFiles])

    //Fetch guide de réparations
    const getGuide = () => {
        const fileReparation: FilesModel[] = files.filter((file: FilesModel) => file.name === REPARATIONS)
        const a = document.createElement('a')
        a.href = fileReparation[0].url
        a.target = '_blank'

        if (process.env.REACT_APP_TARGET === portals.campus) {
            a.download = fileReparation[0].name
        }

        a.click()
    }

    //Go to contracts tab on documents tab
    const goToDocuments = () => {
        saveInteractions(
            {
                category: 'Tableau de bord',
                action: 'Menu Accès Rapide',
                label: 'Vos documents'
            }
        )

        history.push(`${links.contract}${links.tabContract}${contractsTabEnum.documentsTab}`)
    }

    const goToDemandes = () => {
        saveInteractions(
            {
                category: 'Tableau de bord',
                action: 'Menu Accès Rapide',
                label: 'Déposer une demande'
            }
        )

        history.push(links.requests)
    }

    return (
        <>
            <div className={submenuClass}>
				<span className={linksClass} onClick={() => goToDocuments()}>
					<span>
                        <img src={`img/dashboard/${process.env.REACT_APP_TARGET}/contracts.png`}
                             alt="Contracts icon" />
						<FormattedMessage
                            id="dashboard.documents"
                            defaultMessage="Vos documents"
                            description="Dashboard header documents text"
                        />
					</span>
                    {
                        !isLargeScreen &&
						<ChevronRightIcon />
                    }
				</span>

                <span
                    className={linksClass}
                    onClick={() => {
                        saveInteractions(
                            {
                                category: 'Tableau de bord',
                                action: 'Menu Accès Rapide',
                                label: 'Questions fréquentes'
                            }
                        )

                        history.push(links.questions)
                    }}
                >
					<span>
						<img src={`img/dashboard/${process.env.REACT_APP_TARGET}/faq.png`} alt="Faq icon" />

						<FormattedMessage
                            id="dashboard.questions"
                            defaultMessage="Questions fréquentes"
                            description="Dashboard header questions text"
                        />
					</span>

                    {
                        !isLargeScreen &&
						<ChevronRightIcon />
                    }
				</span>

                <span
                    className={linksClass}
                    onClick={() => displayModal(modalTypes.demandes, { callback: goToDemandes })}
                >
					<span>
						<img src={`img/dashboard/${process.env.REACT_APP_TARGET}/email.png`} alt="Email icon" />

						<FormattedMessage
                            id="dashboard.request"
                            defaultMessage="Déposer une demande"
                            description="Dashboard header request text"

                        />
					</span>

                    {
                        !isLargeScreen &&
						<ChevronRightIcon />
                    }
				</span>

                <span
                    className={linksClass}
                    onClick={() => {
                        saveInteractions(
                            {
                                category: 'Tableau de bord',
                                action: 'Menu Accès Rapide',
                                label: 'Guide des réparations locatives'
                            }
                        )

                        getGuide()
                    }}
                >
					<img src={`img/dashboard/${process.env.REACT_APP_TARGET}/repair.png`} alt="Repair icon" />

					<FormattedMessage
                        id="dashboard.repair"
                        defaultMessage="Guide des réparations locatives"
                        description="Dashboard header repair text"
                    />

                    {
                        !isLargeScreen &&
						<ChevronRightIcon />
                    }
				</span>
            </div>

        </>
    )
}

const mapStateToProps = (state: RootState) =>
    (
        {
            files: state.youfirstFiles
        }
    )

const mapDispatchToProps = {
    saveFiles,
    displayModal
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHeaderSubmenu)